import { useEffect, useState } from "react"

export const useApiGrid = () =>{
  
const [api, setApi] = useState<any>(undefined)
const [columnApi, setColumnApi] = useState<any>(undefined)

useEffect(()=>{
  columnApi && autoSizeAll();
},[columnApi])

const setApis = (newApi:any, newColumnApi:any) =>{
  setApi(newApi);
  setColumnApi(newColumnApi);
}

const UpdateRow = (row:any) =>{
  let rowNode = api.getRowNode(row.id);
  rowNode.setData(row);
}

const autoSizeAll = () => {
  let allColumnIds:any = [];
  columnApi.getAllColumns().forEach(function (column:any) {
    allColumnIds.push(column.colId);
  });
  columnApi.autoSizeColumns(allColumnIds);
}

const rowApi = {
  updateRow:UpdateRow
}

  return {...{setApis:setApis, api:api, columnApi: columnApi,rowApi:rowApi}}
}